// this simply returns a unique key to distinguish requests according to filters

const getCacheKey = (packCode: string, startDate: string, endDate: string, season: string, participants: Array<number>, skipass?: number | null): string => {
    return `${packCode} - ${startDate} - ${endDate} - ${season} - ${JSON.stringify(participants)}${skipass ? ` - skipass${skipass}` : ''}`
}

export default getCacheKey